"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMAIlREGEXP = exports.SCHEDULE_MODAL_ID = exports.DINEIN = exports.DELIVERY = exports.CURBSIDEPICKUP = exports.PICKUP = undefined;
exports.checkRestaurantIsOpen = checkRestaurantIsOpen;
exports.getDeliveryAddressStr = getDeliveryAddressStr;
exports.scrollToTop = scrollToTop;

var _MainStore = require("../stores/MainStore");

var _MainStore2 = _interopRequireDefault(_MainStore);

var _CartStore = require("../stores/CartStore");

var _CartStore2 = _interopRequireDefault(_CartStore);

var _ScheduleScreenStore = require("../stores/ScheduleScreenStore");

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _Utility = require("../utils/Utility");

var Utils = _interopRequireWildcard(_Utility);

var _smoothscrollPolyfill = require("smoothscroll-polyfill");

var _smoothscrollPolyfill2 = _interopRequireDefault(_smoothscrollPolyfill);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PICKUP = exports.PICKUP = "PickUp";
var CURBSIDEPICKUP = exports.CURBSIDEPICKUP = "CurbsidePickUp";
var DELIVERY = exports.DELIVERY = "Delivery";
var DINEIN = exports.DINEIN = "DineIn";
// export let DEFAULT_ORDER_TYPE       =  MainStore.getDefaultOrderType();
var SCHEDULE_MODAL_ID = exports.SCHEDULE_MODAL_ID = "schedule_modal";
// export const EMAIlREGEXP              =  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var EMAIlREGEXP = exports.EMAIlREGEXP = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

function checkRestaurantIsOpen() {
    // get date time based on the location
    var dateTime = _MainStore2.default.getCurrentDateTime();
    var orderTypeLocationOpenHours = _CartStore2.default.getOnlineOrderingHours();
    var isLocationOrderTypeOpen = Utils.isResturantOpen(orderTypeLocationOpenHours, dateTime);

    return isLocationOrderTypeOpen;
}

function getDeliveryAddressStr(addressObj) {

    var address = "";
    var addLineStr = "";
    var addLineZip = "";

    if (addressObj != null && !Utils.isEmptyObj(addressObj)) {

        if (addressObj.name) {
            addLineStr = addressObj.name;
        }

        if (addressObj.addLine1) {
            addLineStr = addLineStr + ", " + addressObj.addLine1;
        }

        if (addressObj.addLine2) {
            addLineStr = addLineStr + ", " + addressObj.addLine2;
        }

        if (addressObj.zipCode) {
            addLineZip = addressObj.zipCode;
        }

        if (addressObj.country) {
            addLineZip = addLineZip + ", " + addressObj.country;
        }

        address = addLineStr + ",\n        \n " + addressObj.city + ", " + addLineZip;

        return address;
    } else {
        return "Empty Address";
    }
}

//scroll to the elementId
function scrollToTop(elementId) {
    // kick off the polyfill!
    _smoothscrollPolyfill2.default.polyfill();

    var elem = document.getElementById(elementId);

    if (elem) {
        elem.scrollIntoView({
            block: 'center',
            behavior: "smooth"
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/components/Constants.jsx
// module id = 443
// module chunks = 0